import React, { useState, useRef, useEffect } from 'react';

const QuestionImage = ({ src, alt, className = "lazy-image" }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const imgRef = useRef(null);

  useEffect(() => {
    setIsLoaded(false);

    if (imgRef.current && imgRef.current.complete) {
      setIsLoaded(true);
    }
  }, [src]);

  const handleLoad = () => {
    setIsLoaded(true);
  };

  return (
    <div className="image-wrapper">
      {!isLoaded && (
        <div className="loader-container">
          <div className="circle-loader" />
        </div>
      )}

      <img
        ref={imgRef}
        src={src}
        alt={alt}
        className={`${className} ${isLoaded ? 'loaded' : ''}`}
        onLoad={handleLoad}
        loading="lazy"
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = 'https://placehold.co/600x800?text=Page+Not+Found';
          setIsLoaded(true);
        }}
      />
    </div>
  );
};

export default QuestionImage;